webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setup = undefined;

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueI18n = __webpack_require__(35);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);

var DEFAULT_LANG = 'zh';
var LOCALE_KEY = 'localeLanguage';

var locales = {
  zh: __webpack_require__(53),
  en: __webpack_require__(52)
};

var i18n = new _vueI18n2.default({
  locale: DEFAULT_LANG,
  messages: locales
});

var setup = exports.setup = function setup(lang) {
  if (lang === undefined) {
    lang = window.localStorage.getItem(LOCALE_KEY);
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG;
    }
  }
  window.localStorage.setItem(LOCALE_KEY, lang);

  Object.keys(locales).forEach(function (lang) {
    document.body.classList.remove('lang-' + lang);
  });
  document.body.classList.add('lang-' + lang);
  document.body.setAttribute('lang', lang);

  _vue2.default.config.lang = lang;
  i18n.locale = lang;
};

setup();
exports.default = i18n;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(50);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _home = __webpack_require__(38);

var _home2 = _interopRequireDefault(_home);

var _content = __webpack_require__(37);

var _content2 = _interopRequireDefault(_content);

var _join = __webpack_require__(39);

var _join2 = _interopRequireDefault(_join);

var _partner = __webpack_require__(40);

var _partner2 = _interopRequireDefault(_partner);

var _about = __webpack_require__(36);

var _about2 = _interopRequireDefault(_about);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  mode: 'history',
  routes: [{
    path: '*',
    redirect: '/home'
  }, {
    path: '/home',
    name: 'home',
    component: _home2.default
  }, {
    path: '/content',
    name: 'content',
    component: _content2.default
  }, {
    path: '/content/join',
    name: 'join',
    component: _join2.default
  }, {
    path: '/partner',
    name: 'partner',
    component: _partner2.default
  }, {
    path: '/about',
    name: 'about',
    component: _about2.default
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(47),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(45),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c8842f1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(24)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-61a25d3f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(26)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(48),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-73859cd3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//

exports.default = {
  name: "App"
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    showMore: {
      default: false
    }
  },
  data: function data() {
    return {};
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(3);

exports.default = {
  data: function data() {
    return {
      mobileNavH: "0px"
    };
  },

  methods: {
    showMobileNav: function showMobileNav() {
      document.body.style.overflow = "hidden";
      this.mobileNavH = "100%";
    },
    hiddenMobileNav: function hiddenMobileNav() {
      document.body.style.overflow = "scroll";
      this.mobileNavH = "0px";
    },
    changeLanuageZh: function changeLanuageZh() {
      (0, _index.setup)("zh");
    },
    changeLanuageEn: function changeLanuageEn() {
      (0, _index.setup)("en");
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      show: false
    };
  },
  mounted: function mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    toTop: function toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    handleScroll: function handleScroll() {
      var scrollY = window.pageYOffset;
      if (scrollY > 500) {
        this.show = true;
      } else {
        this.show = false;
      }
    }
  }
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {};
  }
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  data: function data() {
    return {
      broNavActive: 0,
      broNavList: [{
        img: "https://static3.freshin.online/sku/KL-9zsTaiaFOL-lgSEagD1Arjag%3D",
        text: "Kansom"
      }, {
        img: "https://static3.freshin.online/sku/-bMUep%2Bu8FcO6PrhQCLTRTCeEx4%3D",
        text: "A2"
      }, {
        img: "https://static3.freshin.online/sku/RHdFEtvqfn%2BbPKoUBeN4N8LTuNo%3D",
        text: "Dairy farmers"
      }, {
        img: "https://static3.freshin.online/sku/j2c2h0TAzBwvF8S1KkKpD1Sav6A%3D",
        text: "ARNOTTS"
      }, {
        img: "https://static3.freshin.online/sku/DgAz12vfrbvmhR-%2BhJzwxNsjrag%3D",
        text: "Newlait纽兰特"
      }, {
        img: "https://static3.freshin.online/sku/IqhVkSH-y3-PU92tNEl8D4TyeQE%3D",
        text: "go ahead"
      }, {
        img: "https://static3.freshin.online/sku/R-bkKOHMCtqp0BVuDovGi%2Bs%2BlQo%3D",
        text: "single estate dairy单甄"
      }]
    };
  },

  computed: {
    broList: function broList() {
      return [{
        img: "https://static3.freshin.online/sku/KL-9zsTaiaFOL-lgSEagD1Arjag%3D",
        text: this.$t("home.main.main-bottom-bro.main-bottom-bro-main.kansom")
      }, {
        img: "https://static3.freshin.online/sku/-bMUep%2Bu8FcO6PrhQCLTRTCeEx4%3D",
        text: this.$t("home.main.main-bottom-bro.main-bottom-bro-main.a2")
      }, {
        img: "https://static3.freshin.online/sku/RHdFEtvqfn%2BbPKoUBeN4N8LTuNo%3D",
        text: this.$t("home.main.main-bottom-bro.main-bottom-bro-main.dairyfarmers")
      }, {
        img: "https://static3.freshin.online/sku/j2c2h0TAzBwvF8S1KkKpD1Sav6A%3D",
        text: this.$t("home.main.main-bottom-bro.main-bottom-bro-main.arnotts")
      }, {
        img: "https://static3.freshin.online/sku/DgAz12vfrbvmhR-%2BhJzwxNsjrag%3D",
        text: this.$t("home.main.main-bottom-bro.main-bottom-bro-main.newlait")
      }, {
        img: "https://static3.freshin.online/sku/IqhVkSH-y3-PU92tNEl8D4TyeQE%3D",
        text: this.$t("home.main.main-bottom-bro.main-bottom-bro-main.goahead")
      }, {
        img: "https://static3.freshin.online/sku/R-bkKOHMCtqp0BVuDovGi%2Bs%2BlQo%3D",
        text: this.$t("home.main.main-bottom-bro.main-bottom-bro-main.single-estate-dairy")
      }];
    }
  },
  methods: {
    changeindex: function changeindex(index) {
      this.broNavActive = index;
    }
  }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(5);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(4);

var _router2 = _interopRequireDefault(_router);

var _i18n = __webpack_require__(3);

var _i18n2 = _interopRequireDefault(_i18n);

var _headers = __webpack_require__(7);

var _headers2 = _interopRequireDefault(_headers);

var _footers = __webpack_require__(6);

var _footers2 = _interopRequireDefault(_footers);

var _toTop = __webpack_require__(8);

var _toTop2 = _interopRequireDefault(_toTop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_vue2.default.config.productionTip = false;


_vue2.default.component('headers', _headers2.default);
_vue2.default.component('footers', _footers2.default);
_vue2.default.component('toTop', _toTop2.default);
_router2.default.beforeEach(function (to, from, next) {
  document.body.style.overflow = "scroll", next();
});
/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _router2.default,
  i18n: _i18n2.default,
  components: { App: _App2.default },
  template: '<App/>'
});

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoMjU1LCAyNTUsIDI1NSwgMSkiPgogICAgPHBhdGggZD0iTTI0IDRjLTcuNzMgMC0xNCA2LjI3LTE0IDE0IDAgMTAuNSAxNCAyNiAxNCAyNnMxNC0xNS41IDE0LTI2YzAtNy43My02LjI3LTE0LTE0LTE0em0wIDE5Yy0yLjc2IDAtNS0yLjI0LTUtNXMyLjI0LTUgNS01IDUgMi4yNCA1IDUtMi4yNCA1LTUgNXoiPjwvcGF0aD4KICAgIDxwYXRoIGQ9Ik0wIDBoNDh2NDhIMHoiIGZpbGw9Im5vbmUiPjwvcGF0aD4KPC9zdmc+"

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoMjU1LCAyNTUsIDI1NSwgMSkiPgogICAgPHBhdGggZD0iTTQzLjk4IDE2YzAtMS40NC0uNzUtMi42OS0xLjg4LTMuNEwyNCAyIDUuOSAxMi42QzQuNzcgMTMuMzEgNCAxNC41NiA0IDE2djIwYzAgMi4yMSAxLjc5IDQgNCA0aDMyYzIuMjEgMCA0LTEuNzkgNC00bC0uMDItMjB6TTI0IDI2TDcuNDggMTUuNjcgMjQgNmwxNi41MiA5LjY3TDI0IDI2eiI+PC9wYXRoPgogICAgPHBhdGggZD0iTTAgMGg0OHY0OEgweiIgZmlsbD0ibm9uZSI+PC9wYXRoPgo8L3N2Zz4="

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoMjU1LCAyNTUsIDI1NSwgMSkiPgogICAgPHBhdGggZD0iTTAgMGg0OHY0OEgweiIgb3BhY2l0eT0iLjEiIGZpbGw9Im5vbmUiPjwvcGF0aD4KICAgIDxwYXRoIGQ9Ik0yNCAyQzE0LjA2IDIgNiAxMC4wNiA2IDIwdjE0YzAgMy4zMSAyLjY5IDYgNiA2aDZWMjRoLTh2LTRjMC03LjczIDYuMjctMTQgMTQtMTRzMTQgNi4yNyAxNCAxNHY0aC04djE2aDh2MkgyNHY0aDEyYzMuMzEgMCA2LTIuNjkgNi02VjIwYzAtOS45NC04LjA2LTE4LTE4LTE4eiI+PC9wYXRoPgo8L3N2Zz4="

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNTYiIGhlaWdodD0iMjU2IiB2aWV3Qm94PSIwIDAgNDggNDgiIGZpbGw9InJnYmEoMjU1LCAyNTUsIDI1NSwgMSkiPgogICAgPHBhdGggZD0iTTE2IDIyaDZ2MjBoNFYyMmg2bC04LTgtOCA4ek04IDZ2NGgzMlY2SDh6Ij48L3BhdGg+CiAgICA8cGF0aCBkPSJNMCAwaDQ4djQ4SDB6IiBmaWxsPSJub25lIj48L3BhdGg+Cjwvc3ZnPg=="

/***/ }),
/* 35 */,
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(43),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-453090c0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(49),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b7ab1e28",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(19)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(41),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-110dc77c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(44),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b08db72",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(42),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-15154c8a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headers', [_c('div', {
    staticClass: "header-main"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("home.header.hello1")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("home.header.hello2")))]), _vm._v(" "), _c('img', {
    staticClass: "mini-qrcode",
    attrs: {
      "src": "https://static3.freshin.online/sku/jcjUHPoDuNxfBBxMMxyjXZfTvIQ%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.header.hello3")))])])]), _vm._v(" "), _c('section', {
    staticClass: "main container"
  }, [_c('div', {
    staticClass: "main-top"
  }, [_c('ul', {
    staticClass: "main-top-ul"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/NZN7P9JcJvvuy-OPzCCounuIDmc%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-top-li1")))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/im7HpeXJnJZZpZp9v9yU%2B2Lxl7M%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-top-li2")))])]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/rRpHnA1VvKwDPoQTRIMrgVmUJsg%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-top-li3")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-middle"
  }, [_c('section', {
    staticClass: "main-middle-block"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.title")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.subtitle")))]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product1.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product1.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product1.p2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product1.p3")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text order-first"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product2.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product2.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle1.product2.p2")))])])])])]), _vm._v(" "), _c('section', {
    staticClass: "main-middle-block"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.title")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.subtitle")))]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product1.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product1.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product1.p2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product1.p3")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text order-first"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product2.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product2.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product2.p2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle2.product2.p3")))])])])])]), _vm._v(" "), _c('section', {
    staticClass: "main-middle-block"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.title")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.subtitle")))]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product1.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product1.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product1.p2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product1.p3")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-b"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "main-middle-block-text order-first"
  }, [_c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product2.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product2.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product2.p2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("home.main.main-middle3.product2.p3")))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "main-bottom"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "main-bottom-bro"
  }, [_c('h1', [_vm._v("合作伙伴")]), _vm._v(" "), _vm._l((_vm.broList), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.broNavActive == index),
        expression: "broNavActive==index"
      }],
      key: index,
      staticClass: "main-bottom-bro-main"
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])
  }), _vm._v(" "), _c('ul', {
    staticClass: "main-bottom-bro-ul"
  }, _vm._l((_vm.broNavList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        broNavListActive: _vm.broNavActive == index
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeindex(index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.text))])])
  }), 0)], 2)])]), _vm._v(" "), _c('footers', {
    attrs: {
      "showMore": "true"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/KAno-d5mTEPiqYhD%2B%2B9SiCKdc9c%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/tVD-Di6k8bZkFOf36V2Fqdy%2B22g%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/Pb0wJwR%2BILGL2aYjsBGCMFe2bhA%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/xEsHmNCOy9wpWvutvGDFUn-iplU%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/IZyNPgBTIY-NlKwewII2o8eB9JI%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-middle-block-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/n4UN%2BtHBMld0N2UmrjYOn1buvnU%3D",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("鲜入为主深耕全球优质供应链，精选上千款生鲜产品")]), _vm._v(" "), _c('h1', [_vm._v("致同样在用心生活的你")]), _vm._v(" "), _c('div', {
    staticClass: "main-bottom-img"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/OlqWDB6hfyAolhCLLx%2BKbsjLbiU%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/QeY02TP1AdQgYbz4soyRfiPbqbs%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/NFluZ2VeF2dbHiJDTd8Rbr7eoJM%3D",
      "alt": ""
    }
  })])])
}]}

/***/ }),
/* 42 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headers', [_c('div', {
    staticClass: "header-main"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("partner.header.h1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("partner.header.p")))])])]), _vm._v(" "), _c('section', {
    staticClass: "main container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("partner.main.q1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("partner.main.a1")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/qzVWMPj2XdrTm4JL1I-EE0ba4N4%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("partner.main.q2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("partner.main.a2")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/DSwG-rDc80GCCIlKpf3YLig2mLs%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("partner.main.requirement.title")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("partner.main.requirement.dlt")))]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("partner.main.requirement.dl")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("partner.main.requirement.bdt")))]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("partner.main.requirement.bd")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("partner.main.requirement.phone")))])]), _vm._v(" "), _c('footers')], 1)
},staticRenderFns: []}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headers'), _vm._v(" "), _c('section', {
    staticClass: "main container"
  }, [_c('div', {
    staticClass: "main-top"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("about.main.name1")))]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t("about.main.value1")))]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/jIlHwsxlPMQQkj1MWYLfcApWpFg%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.main.qrtext")))])])])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("about.main.name2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.main.value2")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/8vODqMHK15fuy2yaT9ew2aKggio%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("about.main.name3")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.main.value3")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/UDgvU9tYxf6wqsrhO3E6D2ROLtw%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("about.main.name4")))]), _vm._v(" "), _c('div', {
    staticClass: "main-flex"
  }, [_c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/y7hWu2o9w5GnWraBaYvnda8lykU%3D",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t("about.main.value4")))])])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t("about.main.name5")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.main.value5")))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://static3.freshin.online/sku/KRzy86VgxoTB5vZdqNSZMAiQQmY%3D",
      "alt": ""
    }
  })]), _vm._v(" "), _c('footers')], 1)
},staticRenderFns: []}

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headers', [_c('div', {
    staticClass: "header-main"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("join.header.h1")))]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#job1"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job1")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job2"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job2")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job3"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job3")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job4"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job4")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job5"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job5")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job6"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job6")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#job7"
    }
  }, [_vm._v(_vm._s(_vm.$t("join.header.job7")))])])]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("join.header.email")))])])]), _vm._v(" "), _c('section', {
    staticClass: "main container"
  }, [_c('ul', {
    staticClass: "job-ul"
  }, [_c('li', {
    attrs: {
      "id": "job1"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job1.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job1.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job1.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job1.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job1.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job1.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job2"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job2.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job2.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job2.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job2.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job2.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job2.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job3"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job3.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job3.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job3.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job3.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job3.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job3.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job4"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job4.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job4.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job4.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job4.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job4.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job4.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job5"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job5.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job5.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job5.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job5.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job5.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job5.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job6"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job6.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job6.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job6.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job6.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job6.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job6.require.value")))])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "job7"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("join.main.job7.name")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job7.topjd")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job7.duty.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job7.duty.value")))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t("join.main.job7.require.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("join.main.job7.require.value")))])])])]), _vm._v(" "), _c('footers')], 1)
},staticRenderFns: []}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('footer', {
    staticClass: "container"
  }, [(_vm.showMore) ? _c('div', [_c('h1', [_vm._v("联系我们")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "footer-ul"
  }, [_c('li', [_c('h2', [_vm._v("市场合作")]), _vm._v(" "), _c('p', [_vm._v("市场合作,资源互换请将信息")]), _vm._v(" "), _c('p', [_vm._v("发送至: marketing@freshin.com")])]), _vm._v(" "), _c('li', [_c('h2', [_vm._v("品牌合作")]), _vm._v(" "), _c('p', [_vm._v("品牌整体推广、品牌合作、品牌活动")]), _vm._v(" "), _c('p', [_vm._v("发送至: branding@freshin.com")])]), _vm._v(" "), _c('li', [_c('h2', [_vm._v("媒体合作")]), _vm._v(" "), _c('p', [_vm._v("媒体采访、内容合作等")]), _vm._v(" "), _c('p', [_vm._v("请联系: media@freshin.com")])]), _vm._v(" "), _c('li', [_c('h2', [_vm._v("手机市场合作等")]), _vm._v(" "), _c('p', [_vm._v("手机市场合作等")]), _vm._v(" "), _c('p', [_vm._v("请联系: app@freshin.com")])]), _vm._v(" "), _c('li', [_c('h2', [_vm._v("澳大利亚办事处")]), _vm._v(" "), _c('p', [_vm._v("Phone: +61 (0) 450 930 719")]), _vm._v(" "), _c('p', [_vm._v("Address：101 shafer road, Blackburn north")]), _vm._v(" "), _c('p', [_vm._v("VIC 3130, Australia")])]), _vm._v(" "), _c('li', [_c('h2', [_vm._v("中国总部")]), _vm._v(" "), _c('p', [_vm._v("电话: 0571-88668673")]), _vm._v(" "), _c('p', [_vm._v("邮箱: info@freshin.com")]), _vm._v(" "), _c('p', [_vm._v("地址：中国浙江省杭州市余杭区")]), _vm._v(" "), _c('p', [_vm._v("文一西路中国人工智能小镇3号楼303室")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("\n      © 2015-2019 freshin.com freshin.online 版权所有\n      "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://beian.miit.gov.cn/"
    }
  }, [_vm._v("浙ICP备19005668号-1")])])
}]}

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header bg"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "header-top-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-top-r"
  }, [_c('div', {
    staticClass: "pc-nav"
  }, [_c('div', {
    staticClass: "pc-nav-flex"
  }, [_c('nav', [_c('ul', {
    staticClass: "nav"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "nav-active",
      "to": "/home"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav1")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "nav-active",
      "to": "/content"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav2")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "nav-active",
      "to": "/partner"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav3")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "active-class": "nav-active",
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav4")))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "i18"
  }, [_c('span', {
    class: {
      'i18-hidden': this.$i18n.locale == 'en'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeLanuageZh.apply(null, arguments)
      }
    }
  }, [_vm._v("中文")]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('span', {
    class: {
      'i18-hidden': this.$i18n.locale == 'zh'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeLanuageEn.apply(null, arguments)
      }
    }
  }, [_vm._v("English")])])])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav"
  }, [_c('div', {
    staticClass: "mobile-nav-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showMobileNav.apply(null, arguments)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 60 60",
      "preserveAspectRatio": "none"
    }
  }, [_c('g', {
    attrs: {
      "id": "icon-grid",
      "fill": "#fff"
    }
  }, [_c('rect', {
    attrs: {
      "x": "4.5",
      "y": "2.5",
      "width": "50",
      "height": "5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "4.5",
      "y": "22.5",
      "width": "50",
      "height": "5"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "4.5",
      "y": "42.5",
      "width": "50",
      "height": "5"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "icon-cross"
    }
  }, [_c('line', {
    attrs: {
      "x1": "4.5",
      "y1": "55.5",
      "x2": "54.953",
      "y2": "5.046"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.953",
      "y1": "55.5",
      "x2": "4.5",
      "y2": "5.047"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav-block",
    style: ({
      height: _vm.mobileNavH
    })
  }, [_c('div', {}, [_c('ul', {
    staticClass: "mobile-nav-ul"
  }, [_c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/home"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav1")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/content"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav2")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/partner"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav3")))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "li",
      "to": "/about"
    }
  }, [_vm._v(_vm._s(_vm.$t("header.nav4")))]), _vm._v(" "), _c('li', [_c('span', {
    class: {
      'i18-hidden': this.$i18n.locale == 'en'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeLanuageZh.apply(null, arguments)
      }
    }
  }, [_vm._v("中文")]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('span', {
    class: {
      'i18-hidden': this.$i18n.locale == 'zh'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeLanuageEn.apply(null, arguments)
      }
    }
  }, [_vm._v("English")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mobile-nav-close-icon",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hiddenMobileNav.apply(null, arguments)
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 60 60",
      "preserveAspectRatio": "none"
    }
  }, [_c('g', {
    attrs: {
      "id": "icon-cross"
    }
  }, [_c('line', {
    attrs: {
      "x1": "4.5",
      "y1": "55.5",
      "x2": "54.953",
      "y2": "5.046"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "54.953",
      "y1": "55.5",
      "x2": "4.5",
      "y2": "5.047"
    }
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-top-l"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://static3.freshin.online/sku/MhU6EcFPoRN5Ppnb9Wg-1-KU5bI%3D",
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('toTop')], 1)
},staticRenderFns: []}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "block",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toTop.apply(null, arguments)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(34),
      "alt": ""
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('headers', [_c('div', {
    staticClass: "header-main"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("content.header.h1")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("content.header.h2")))]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": __webpack_require__(31),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("content.header.p1")))])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": __webpack_require__(32),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("content.header.p2")))])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": __webpack_require__(33),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("content.header.p3")))])])])]), _vm._v(" "), _c('section', {
    staticClass: "main container"
  }, [_c('div', {
    staticClass: "main-join"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("content.main.main-join.h1")))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("content.main.main-join.h2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("content.main.main-join.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("content.main.main-join.p2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("content.main.main-join.p3")))]), _vm._v(" "), _c('router-link', {
    staticClass: "todetail-btn",
    attrs: {
      "to": "/content/join"
    }
  }, [_vm._v(_vm._s(_vm.$t("content.main.main-join.btn")))])], 1), _vm._v(" "), _c('div', {
    staticClass: "main-Cooperation"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.h1")))]), _vm._v(" "), _c('ul', [_c('li', [_c('h3', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li1.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li1.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li1.p2")))])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li2.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li2.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li2.p2")))])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li3.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li3.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li3.p2")))])]), _vm._v(" "), _c('li', [_c('h3', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li3.title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li4.p1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("content.main.main-Cooperation.li4.p2")))])])])])]), _vm._v(" "), _c('footers')], 1)
},staticRenderFns: []}

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, exports) {

module.exports = {"header":{"nav1":"Home","nav2":"Contact us","nav3":"Join us","nav4":"About us"},"home":{"header":{"hello1":"让你的生活，每天都是新鲜的。","hello2":"立即进入“freshin鲜入为主官方旗舰店”加入“新鲜中国”计划","hello3":"微信扫一扫 使用小程序"},"main":{"main-top-li1":"专项配送","main-top-li2":"产地溯源","main-top-li3":"海外直供","main-middle1":{"title":"“专项配送”","subtitle":"7天保证快速到手","product1":{"name":"A2鲜奶","p1":"纯天然、无添加","p2":"巴氏杀菌，通过DNA检测","p3":"含全A2 β-酪蛋白，有效避免肠道不适"},"product2":{"name":"sipahh咕噜噜变味吸管","p1":"天然成分，神奇变味","p2":"低糖零脂，健康安全"}},"main-middle2":{"title":"“产地溯源”","subtitle":"所有商品有源可溯","product1":{"name":"TimTam巧克力威化饼干","p1":"趣味吃法，颜值爆表","p2":"可以吸的巧克力饼干","p3":"满足挑剔的味蕾"},"product2":{"name":"dairy farmers酸奶","p1":"巴氏杀菌酸奶+新鲜水果","p2":"纯净自然，口感醇厚","p3":"多种口味，尽情挑选"}},"main-middle3":{"title":"“海外直供”","subtitle":"海外直采避免中间环节","product1":{"name":"KANSOM鲍鱼酱","p1":"世界第一款鲍鱼酱","p2":"高营养价值","p3":"含有浓缩鲍鱼精华"},"product2":{"name":"Go ahead酸奶饼干","p1":"清新酸奶涂层","p2":"满溢果干夹心","p3":"带给您丰富的味蕾体验"}},"main-bottom-bro":{"h1":"合作伙伴","main-bottom-bro-main":{"kansom":"凯盛澳大利亚股份有限公司创立于1985年，致力于制造和推广高级海鲜产品。公司的经营宗旨是以先进的科学技术生产出富有美食传统，文化特色的健康海鲜产品；以高品质，多元化的优质服务为广大顾客带来美食革命的新享受。","a2":"A2有限公司是全球唯一拥有权生产和销售a2<sup>&reg;</sup>品牌乳制品经营权的公司。a2<sup>&reg;</sup>品牌牛奶是鲜奶产品，纯天然、无添加、源自含有纯A2 β-酪蛋白的奶牛。所有的A2奶牛都是通过DNA测试验证，并通过认证以确保产出的牛奶只含有A2型的β-酪蛋白","dairyfarmers":"Dairy Farmers精选优质的原材料本着原汁原味的理念，是澳洲本土市场中十分畅销、特别受欢迎的酸奶品牌。“牛奶对我们来说，至关重要”——这是Dairy Farmers成为澳大利亚全国上下值得信赖的乳制品品牌原因，被誉为“澳洲国民酸奶”以及“酸奶中的爱马仕”。","arnotts":"ARNOTTS是享誉全球的澳洲巧克力饼干品牌，巧克力饼干中的“劳斯莱斯”。","newlait":"Newlait纽兰特全天然、全程无污染。拒绝使用基因饲料，生产过程中严禁使用化肥、农药和生长激素等化学物质。","goahead":"go ahead果味饼干品牌源自英国，在1996年作为一个完全健康的传统饼干被推出，现在是英国卓越的健康食品品牌之一，go head专注于水果口味并且产品丰富。","single-estate-dairy":"Single Estate Dairy的牧场位于南威尔士北部的Goolmangar，广阔的生活空间、优质的水源、天然的牧草以及100%杜绝奶牛抗生素、人工饲料和生长激素，让鲜奶品质有了多重保障"}}}},"content":{"header":{"h1":"联系我们","h2":"杭州鲜入为主进出口贸易有限公司","p1":"地址：中国浙江省杭州市余杭区文一西路中国人工智能小镇3号楼303室","p2":"邮编：3100000","p3":"电话：0571-88668673"},"main":{"main-join":{"h1":"加入我们","h2":"吃喝玩乐在一起，这才是工作","p1":"1.有匹配度的薪资+福利；","p2":"2.工作能力拓展带给你无限可能性和成就感；","p3":"3.季度拿大奖；Party狂欢月；速度与激情、吃喝玩乐的文化气氛。","btn":"查看详情"},"main-Cooperation":{"h1":"业务合作","li1":{"title":"市场合作","p1":"市场合作,资源互换请将信息","p2":"发送至: marketing@freshin.com"},"li2":{"title":"品牌合作","p1":"品牌整体推广、品牌合作、品牌活动","p2":"发送至: branding@freshin.com"},"li3":{"title":"媒体合作","p1":"媒体采访、内容合作等","p2":"请联系: media@freshin.com"},"li4":{"title":"手机市场合作等","p1":"手机市场合作等","p2":"请联系: app@freshin.com"}}}},"join":{"header":{"h1":"加入我们","job1":"视觉设计师 >","job2":"前端开发工程师 >","job3":"Nodejs高级开发工程师 >","job4":"商务拓展经理 >","job5":"商务拓展专员 >","job6":"物流助理 >","job7":"客服 >","email":"简历投递邮箱：hr@freshin.com"},"main":{"job1":{"name":"视觉设计师","topjd":"杭州/全职/2年以上工作经验","duty":{"title":"岗位职责","value":"1.准确理解产品需求，主导移动端App的视觉设计，把控设计方案，参与设计体验、流程的制定和规范；\n2.具备一定的项目推动力，关注所负责产品的设计动向，提供专业的意见及建议；\n3.有丰富的设计理论知识和对流行趋势敏锐的洞察力，对GUI设计趋势有灵敏触觉和领悟能力，推动团队的设计能力。"},"require":{"title":"岗位要求","value":"1.从事GUI设计3年及以上，具有大型软件产品界面风格设定以及VI设定（包括界面、图标风格与统一规范等）经验；\n2.具备一定的项目推动力，关注所负责产品的设计动向，提供专业的意见及建议；\n3.具有良好的沟通和推动能力以及团队协作能力。"}},"job2":{"name":"前端开发工程师","topjd":"杭州/全职/2年以上工作经验","duty":{"title":"岗位职责","value":"1.依据产品需求完成高质量的Web前端开发和维护；\n2.对具体的产品进行性能优化，实现极致的Web加载、执行和渲染时间。"},"require":{"title":"岗位要求","value":"1.精通各种Web前端技术（HTML/CSS/Javascript等），熟练跨浏览器、跨终端的开发；\n2.精通常见的前端开发库，例如：JQuery、Angular.js、Bootstrap等；\n3.有中大型前端架构、前端性能、可访问性、可维护性等方面的实践经验；\n4.熟练一门前端脚本语言（如：NodeJS /Python等）优先考虑；\n5.自我管理能力强良好，健康的创业心态，快速的学习能力，乐于分享与沟通。"}},"job3":{"name":"Nodejs高级开发工程师","topjd":"杭州/全职/2年以上工作经验","duty":{"title":"岗位职责","value":"1.依据产品需求完成高质量的Web前端开发和维护；\n2.对具体的产品进行性能优化，实现极致的Web加载、执行和渲染时间。"},"require":{"title":"岗位要求","value":"1.精通Javascript，有3年以上相关项目经验；\n2.至少1年以上Nodejs开发经验，熟练使用Express、KOA等主流web框架；\n3.对Restful API理念认同并有项目实践；\n4.熟练HTML、CSS等Web前端技术栈；\n5.熟悉Linux/Unix、MySQL、Nginx，有良好的编码和文档写作习惯；\n6.重视团队协作，掌握git等开发协作工具。"}},"job4":{"name":"商务拓展经理","topjd":"杭州/全职","duty":{"title":"岗位职责","value":"1.有电子商务运营平台（生鲜食品、跨境电商）的潜在合作渠道关系如：广告联盟、自媒体、地方行业协会和服务提供商等，制定与合作伙伴平台渠道对接的产品策略、用户策略，制定线上产品销售、用户引流方针；\n2.执行公司制定的业务发展方案，通过新客户拓展和核心客户维护完成区域性销售目标，支持战略发展计划；\n3.负责与合作伙伴的沟通、谈判，对成功合作的进行管理，维护用户发展渠道和合作关系；\n4.参与确认新产品、新商品推广方式以及线下产品体验活动组织实施；\n5.组织完成本业务单元的市场调查，分析、改善及丰富相关产品品类、合作渠道。"},"require":{"title":"岗位要求","value":"1.专科及以上学历，市场营销、管理类相关专业；\n2.3年以上同岗位工作经验，具有电商平台合作渠道资源者优先考虑；拥有广泛的人脉资源；\n3.具有较强的市场敏锐力、沟通谈判能力、团队管理能力与目标推进能力；\n4.工作中积极进取，擅长自我激励与激励他人，能承受快速发展型企业带来的工作压力。"}},"job5":{"name":"商务拓展专员","topjd":"杭州/全职","duty":{"title":"","value":""},"require":{"title":"岗位要求","value":"1.市场渠道拓展开发的管理经验以及搭建团队的能力和销售能力；\n2.有自己独特的思维模式，简单韧性；\n3.熟悉各大互联网媒体以及同行推广渠道；\n4.协助市场制定C端用户推广方案；\n5.有自己对用户生命周期的运作思路。"}},"job6":{"name":"物流助理","topjd":"杭州/全职","duty":{"title":"岗位职责","value":"1.配合并完成主管交付的日常物流管理工作，包括但不仅限于包材物料采购，物流方案信息收集，海关商检及物流合作伙伴的日常沟通工作等；\n2.配送管理:管理和优化承运商，降低整体运输成本，统筹安排日常配送任务，提高故障处理和恢复能力，确保及时供货；\n3.仓储管理:负责物料的接收、保管和发放，保证帐、物、卡相符及各种报表的及时准确性；监控库存及仓储成本，确保物料安全，提高周转率；\n4.现场作业管理:组织安排物料的搬运、装卸和包装等现场作业任务，监督、规范业务操作流程，确保产品和服务质量；\n5.报表管理：负责按时编制各类相关物流管理报表，及时向上级回报。"},"require":{"title":"岗位要求","value":"1.大专及以上学历，物流类或贸易类相关专业（优先）；\n2.熟悉物流管理、国际贸易，供应链管理的相关流程及知识，熟悉公司业务知识和财务基础知识；\n3.具备良好的计划、管理、沟通和协调能力；\n4.责任心强，诚信、细致，有较强的团队合作意识；\n5.要求英文6级，熟练运用办公软件和协同作业软件，Photoshop,做好支出收入流水账登记；\n5.有两年以上驾驶经验以及个人有效驾照。"}},"job7":{"name":"客服","topjd":"杭州/全职","duty":{"title":"岗位职责","value":"1.电话解答客户售后服务和保险理赔问题，熟练准确判断生鲜商品坏损情况和原因并指导客户进行正确的理赔；\n2.保证良好的客户沟通界面以及服务的专业性；\n3.处理生鲜品类的其他售后问题；"},"require":{"title":"岗位要求","value":"1.大专及以上学历，1年左右客服从业经验；\n2.拥有专业的生鲜品类经验或有生鲜热线服务经验优先考虑；懂生鲜理赔、消法优先；\n3.有良好的情绪管控能力，对于投诉能保持冷静克制；\n4.有客服服务从业经验，并对客服工作有正面认知；\n5.每周工作5天，能适应周一到周日的倒班及晚班（13:00-21:00）。 工作时间:做六休一，倒班制。 补充：三类人选可符合要求。\nA类，呼叫中心+生鲜产品经验，学历可放宽至中专；\nB类，呼叫中心或生鲜产品经验，学历大专；\nC类，有生鲜产品销售经验，想往客服/呼叫中心转的人选，接受倒班和晚班，学历大专。"}}}},"partner":{"header":{"h1":"成为鲜入为主合伙人","p":"如果你敢想敢拼，如果你勇于尝试\n请让我找到你，让我们向钱看，向厚赚\n鲜入为主拉你一起搞事情"},"main":{"q1":"什么是鲜入为主合伙人？","a1":"鲜入为主合伙人分两种模式，一种是代理，一种是BD。","q2":"成为鲜入为主合伙人，有哪些优势？","a2":"鲜入为主团队在海外大量采购商品，和品牌直接合作，获得了很好的折扣，\n按照跨境电商的方法，进入国内，给国内消费者带来了巨大的优惠。","requirement":{"title":"鲜入为主合伙人条件","dlt":"代理：","dl":"品行端正，诚信正直，有责任心有担当，能吃苦有创业精神，能够承担一定程度的压力。\n具有一定的管理经营理念\n有广泛的人脉关系 能利用微信生态圈寻找顾客，锁定顾客，建立合作关系，维护好老顾客\n收集和分析数据，并定时总结\n能够熟练使用微信小程序，支付宝等…\n具备独立处理复杂问题和紧急事情的能力","bdt":"BD：","bd":"品行端正，诚信正直，有责任心有担当，能吃苦有创业精神，能够承担一定程度的压力。\n具有一定的管理经营理念，有线下中高档零售店门店资源者优先\n收集和分析数据，并定时总结\n能够熟练使用微信小程序，支付宝等…\n具备独立处理复杂问题和紧急事情的能力","phone":"合伙人咨询电话：133 3613 6613"}}},"about":{"main":{"name1":"公司简介","value1":"2015年启程的鲜入为主Freshin，致力于跨境生鲜健康食品的直采直供以及在线用户交互管理。作为一家新兴的电子商务公司，我们运作于不同的市场领域，并和各行各业的渠道合作商有着广泛的接触。\n\n我们的业务领域专注于全球供应商优质生鲜健康食品基于用户碎片时间体验以及在线购买，在帮助消费者实现购买决策，满足消费者对于高质量生活方式追求的同时，我们总能联合我们诸多合作伙伴的实力、资源和精英，以一个完整统一的团队出现在我们的平台中。\n\n为了实现这个目标，我们坚持同一个愿景、使命、价值观和经营原则，并以此引导我们和合作伙伴的日常工作。","qrtext":"新人注册领取优惠券\n扫码进入小程序购买","name2":"我们的使命","value2":"为中国老百姓的健康和品质生活做出贡献","name3":"我们的愿景","value3":"使鲜入为主®成为中国最具竞争力的健康品质生活品牌","name4":"我们的价值观","value4":"客户第一，客户是衣食父母\n共享共担，平凡人做平凡事\n迎接变化，勇于创新\n诚实正直，言行坦荡\n乐观向上，永不放弃\n专业执着，精益求精","name5":"鲜入为主深耕全球优质供应链，精选上千款生鲜产品","value5":"产品分类多样，主打生鲜乳制品，鲜入为主深耕全球优质供应链，精选上千款生鲜产品，\n30个国家直采，首次挑选合格率高达95%的产品才有资格二次入库挑选，只为您提供更优质服务。"}}}

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = {"header":{"nav1":"首页","nav2":"联系我们","nav3":"加盟我们","nav4":"关于我们"},"home":{"header":{"hello1":"让你的生活，每天都是新鲜的。","hello2":"立即进入“freshin鲜入为主官方旗舰店”加入“新鲜中国”计划","hello3":"微信扫一扫 使用小程序"},"main":{"main-top-li1":"专项配送","main-top-li2":"产地溯源","main-top-li3":"海外直供","main-middle1":{"title":"“专项配送”","subtitle":"7天保证快速到手","product1":{"name":"A2鲜奶","p1":"纯天然、无添加","p2":"巴氏杀菌，通过DNA检测","p3":"含全A2 β-酪蛋白，有效避免肠道不适"},"product2":{"name":"sipahh咕噜噜变味吸管","p1":"天然成分，神奇变味","p2":"低糖零脂，健康安全"}},"main-middle2":{"title":"“产地溯源”","subtitle":"所有商品有源可溯","product1":{"name":"TimTam巧克力威化饼干","p1":"趣味吃法，颜值爆表","p2":"可以吸的巧克力饼干","p3":"满足挑剔的味蕾"},"product2":{"name":"dairy farmers酸奶","p1":"巴氏杀菌酸奶+新鲜水果","p2":"纯净自然，口感醇厚","p3":"多种口味，尽情挑选"}},"main-middle3":{"title":"“海外直供”","subtitle":"海外直采避免中间环节","product1":{"name":"KANSOM鲍鱼酱","p1":"世界第一款鲍鱼酱","p2":"高营养价值","p3":"含有浓缩鲍鱼精华"},"product2":{"name":"Go ahead酸奶饼干","p1":"清新酸奶涂层","p2":"满溢果干夹心","p3":"带给您丰富的味蕾体验"}},"main-bottom-bro":{"h1":"合作伙伴","main-bottom-bro-main":{"kansom":"凯盛澳大利亚股份有限公司创立于1985年，致力于制造和推广高级海鲜产品。公司的经营宗旨是以先进的科学技术生产出富有美食传统，文化特色的健康海鲜产品；以高品质，多元化的优质服务为广大顾客带来美食革命的新享受。","a2":"A2有限公司是全球唯一拥有权生产和销售a2<sup>&reg;</sup>品牌乳制品经营权的公司。a2<sup>&reg;</sup>品牌牛奶是鲜奶产品，纯天然、无添加、源自含有纯A2 β-酪蛋白的奶牛。所有的A2奶牛都是通过DNA测试验证，并通过认证以确保产出的牛奶只含有A2型的β-酪蛋白","dairyfarmers":"Dairy Farmers精选优质的原材料本着原汁原味的理念，是澳洲本土市场中十分畅销、特别受欢迎的酸奶品牌。“牛奶对我们来说，至关重要”——这是Dairy Farmers成为澳大利亚全国上下值得信赖的乳制品品牌原因，被誉为“澳洲国民酸奶”以及“酸奶中的爱马仕”。","arnotts":"ARNOTTS是享誉全球的澳洲巧克力饼干品牌，巧克力饼干中的“劳斯莱斯”。","newlait":"Newlait纽兰特全天然、全程无污染。拒绝使用基因饲料，生产过程中严禁使用化肥、农药和生长激素等化学物质。","goahead":"go ahead果味饼干品牌源自英国，在1996年作为一个完全健康的传统饼干被推出，现在是英国卓越的健康食品品牌之一，go head专注于水果口味并且产品丰富。","single-estate-dairy":"Single Estate Dairy的牧场位于南威尔士北部的Goolmangar，广阔的生活空间、优质的水源、天然的牧草以及100%杜绝奶牛抗生素、人工饲料和生长激素，让鲜奶品质有了多重保障"}}}},"content":{"header":{"h1":"联系我们","h2":"杭州鲜入为主进出口贸易有限公司","p1":"地址：中国浙江省杭州市余杭区文一西路中国人工智能小镇3号楼303室","p2":"邮编：3100000","p3":"电话：0571-88668673"},"main":{"main-join":{"h1":"加入我们","h2":"吃喝玩乐在一起，这才是工作","p1":"1.有匹配度的薪资+福利；","p2":"2.工作能力拓展带给你无限可能性和成就感；","p3":"3.季度拿大奖；Party狂欢月；速度与激情、吃喝玩乐的文化气氛。","btn":"查看详情"},"main-Cooperation":{"h1":"业务合作","li1":{"title":"市场合作","p1":"市场合作,资源互换请将信息","p2":"发送至: marketing@freshin.com"},"li2":{"title":"品牌合作","p1":"品牌整体推广、品牌合作、品牌活动","p2":"发送至: branding@freshin.com"},"li3":{"title":"媒体合作","p1":"媒体采访、内容合作等","p2":"请联系: media@freshin.com"},"li4":{"title":"手机市场合作等","p1":"手机市场合作等","p2":"请联系: app@freshin.com"}}}},"join":{"header":{"h1":"加入我们","job1":"视觉设计师 >","job2":"前端开发工程师 >","job3":"Nodejs高级开发工程师 >","job4":"商务拓展经理 >","job5":"商务拓展专员 >","job6":"物流助理 >","job7":"客服 >","email":"简历投递邮箱：hr@freshin.com"},"main":{"job1":{"name":"视觉设计师","topjd":"杭州/全职/2年以上工作经验","duty":{"title":"岗位职责","value":"1.准确理解产品需求，主导移动端App的视觉设计，把控设计方案，参与设计体验、流程的制定和规范；\n2.具备一定的项目推动力，关注所负责产品的设计动向，提供专业的意见及建议；\n3.有丰富的设计理论知识和对流行趋势敏锐的洞察力，对GUI设计趋势有灵敏触觉和领悟能力，推动团队的设计能力。"},"require":{"title":"岗位要求","value":"1.从事GUI设计3年及以上，具有大型软件产品界面风格设定以及VI设定（包括界面、图标风格与统一规范等）经验；\n2.具备一定的项目推动力，关注所负责产品的设计动向，提供专业的意见及建议；\n3.具有良好的沟通和推动能力以及团队协作能力。"}},"job2":{"name":"前端开发工程师","topjd":"杭州/全职/2年以上工作经验","duty":{"title":"岗位职责","value":"1.依据产品需求完成高质量的Web前端开发和维护；\n2.对具体的产品进行性能优化，实现极致的Web加载、执行和渲染时间。"},"require":{"title":"岗位要求","value":"1.精通各种Web前端技术（HTML/CSS/Javascript等），熟练跨浏览器、跨终端的开发；\n2.精通常见的前端开发库，例如：JQuery、Angular.js、Bootstrap等；\n3.有中大型前端架构、前端性能、可访问性、可维护性等方面的实践经验；\n4.熟练一门前端脚本语言（如：NodeJS /Python等）优先考虑；\n5.自我管理能力强良好，健康的创业心态，快速的学习能力，乐于分享与沟通。"}},"job3":{"name":"Nodejs高级开发工程师","topjd":"杭州/全职/2年以上工作经验","duty":{"title":"岗位职责","value":"1.依据产品需求完成高质量的Web前端开发和维护；\n2.对具体的产品进行性能优化，实现极致的Web加载、执行和渲染时间。"},"require":{"title":"岗位要求","value":"1.精通Javascript，有3年以上相关项目经验；\n2.至少1年以上Nodejs开发经验，熟练使用Express、KOA等主流web框架；\n3.对Restful API理念认同并有项目实践；\n4.熟练HTML、CSS等Web前端技术栈；\n5.熟悉Linux/Unix、MySQL、Nginx，有良好的编码和文档写作习惯；\n6.重视团队协作，掌握git等开发协作工具。"}},"job4":{"name":"商务拓展经理","topjd":"杭州/全职","duty":{"title":"岗位职责","value":"1.有电子商务运营平台（生鲜食品、跨境电商）的潜在合作渠道关系如：广告联盟、自媒体、地方行业协会和服务提供商等，制定与合作伙伴平台渠道对接的产品策略、用户策略，制定线上产品销售、用户引流方针；\n2.执行公司制定的业务发展方案，通过新客户拓展和核心客户维护完成区域性销售目标，支持战略发展计划；\n3.负责与合作伙伴的沟通、谈判，对成功合作的进行管理，维护用户发展渠道和合作关系；\n4.参与确认新产品、新商品推广方式以及线下产品体验活动组织实施；\n5.组织完成本业务单元的市场调查，分析、改善及丰富相关产品品类、合作渠道。"},"require":{"title":"岗位要求","value":"1.专科及以上学历，市场营销、管理类相关专业；\n2.3年以上同岗位工作经验，具有电商平台合作渠道资源者优先考虑；拥有广泛的人脉资源；\n3.具有较强的市场敏锐力、沟通谈判能力、团队管理能力与目标推进能力；\n4.工作中积极进取，擅长自我激励与激励他人，能承受快速发展型企业带来的工作压力。"}},"job5":{"name":"商务拓展专员","topjd":"杭州/全职","duty":{"title":"","value":""},"require":{"title":"岗位要求","value":"1.市场渠道拓展开发的管理经验以及搭建团队的能力和销售能力；\n2.有自己独特的思维模式，简单韧性；\n3.熟悉各大互联网媒体以及同行推广渠道；\n4.协助市场制定C端用户推广方案；\n5.有自己对用户生命周期的运作思路。"}},"job6":{"name":"物流助理","topjd":"杭州/全职","duty":{"title":"岗位职责","value":"1.配合并完成主管交付的日常物流管理工作，包括但不仅限于包材物料采购，物流方案信息收集，海关商检及物流合作伙伴的日常沟通工作等；\n2.配送管理:管理和优化承运商，降低整体运输成本，统筹安排日常配送任务，提高故障处理和恢复能力，确保及时供货；\n3.仓储管理:负责物料的接收、保管和发放，保证帐、物、卡相符及各种报表的及时准确性；监控库存及仓储成本，确保物料安全，提高周转率；\n4.现场作业管理:组织安排物料的搬运、装卸和包装等现场作业任务，监督、规范业务操作流程，确保产品和服务质量；\n5.报表管理：负责按时编制各类相关物流管理报表，及时向上级回报。"},"require":{"title":"岗位要求","value":"1.大专及以上学历，物流类或贸易类相关专业（优先）；\n2.熟悉物流管理、国际贸易，供应链管理的相关流程及知识，熟悉公司业务知识和财务基础知识；\n3.具备良好的计划、管理、沟通和协调能力；\n4.责任心强，诚信、细致，有较强的团队合作意识；\n5.要求英文6级，熟练运用办公软件和协同作业软件，Photoshop,做好支出收入流水账登记；\n5.有两年以上驾驶经验以及个人有效驾照。"}},"job7":{"name":"客服","topjd":"杭州/全职","duty":{"title":"岗位职责","value":"1.电话解答客户售后服务和保险理赔问题，熟练准确判断生鲜商品坏损情况和原因并指导客户进行正确的理赔；\n2.保证良好的客户沟通界面以及服务的专业性；\n3.处理生鲜品类的其他售后问题；"},"require":{"title":"岗位要求","value":"1.大专及以上学历，1年左右客服从业经验；\n2.拥有专业的生鲜品类经验或有生鲜热线服务经验优先考虑；懂生鲜理赔、消法优先；\n3.有良好的情绪管控能力，对于投诉能保持冷静克制；\n4.有客服服务从业经验，并对客服工作有正面认知；\n5.每周工作5天，能适应周一到周日的倒班及晚班（13:00-21:00）。 工作时间:做六休一，倒班制。 补充：三类人选可符合要求。\nA类，呼叫中心+生鲜产品经验，学历可放宽至中专；\nB类，呼叫中心或生鲜产品经验，学历大专；\nC类，有生鲜产品销售经验，想往客服/呼叫中心转的人选，接受倒班和晚班，学历大专。"}}}},"partner":{"header":{"h1":"成为鲜入为主合伙人","p":"如果你敢想敢拼，如果你勇于尝试\n请让我找到你，让我们向钱看，向厚赚\n鲜入为主拉你一起搞事情"},"main":{"q1":"什么是鲜入为主合伙人？","a1":"鲜入为主合伙人分两种模式，一种是代理，一种是BD。","q2":"成为鲜入为主合伙人，有哪些优势？","a2":"鲜入为主团队在海外大量采购商品，和品牌直接合作，获得了很好的折扣，\n按照跨境电商的方法，进入国内，给国内消费者带来了巨大的优惠。","requirement":{"title":"鲜入为主合伙人条件","dlt":"代理：","dl":"品行端正，诚信正直，有责任心有担当，能吃苦有创业精神，能够承担一定程度的压力。\n具有一定的管理经营理念\n有广泛的人脉关系 能利用微信生态圈寻找顾客，锁定顾客，建立合作关系，维护好老顾客\n收集和分析数据，并定时总结\n能够熟练使用微信小程序，支付宝等…\n具备独立处理复杂问题和紧急事情的能力","bdt":"BD：","bd":"品行端正，诚信正直，有责任心有担当，能吃苦有创业精神，能够承担一定程度的压力。\n具有一定的管理经营理念，有线下中高档零售店门店资源者优先\n收集和分析数据，并定时总结\n能够熟练使用微信小程序，支付宝等…\n具备独立处理复杂问题和紧急事情的能力","phone":"合伙人咨询电话：133 3613 6613"}}},"about":{"main":{"name1":"公司简介","value1":"2015年启程的鲜入为主Freshin，致力于跨境生鲜健康食品的直采直供以及在线用户交互管理。作为一家新兴的电子商务公司，我们运作于不同的市场领域，并和各行各业的渠道合作商有着广泛的接触。\n\n我们的业务领域专注于全球供应商优质生鲜健康食品基于用户碎片时间体验以及在线购买，在帮助消费者实现购买决策，满足消费者对于高质量生活方式追求的同时，我们总能联合我们诸多合作伙伴的实力、资源和精英，以一个完整统一的团队出现在我们的平台中。\n\n为了实现这个目标，我们坚持同一个愿景、使命、价值观和经营原则，并以此引导我们和合作伙伴的日常工作。","qrtext":"新人注册领取优惠券\n扫码进入小程序购买","name2":"我们的使命","value2":"为中国老百姓的健康和品质生活做出贡献","name3":"我们的愿景","value3":"使鲜入为主®成为中国最具竞争力的健康品质生活品牌","name4":"我们的价值观","value4":"客户第一，客户是衣食父母\n共享共担，平凡人做平凡事\n迎接变化，勇于创新\n诚实正直，言行坦荡\n乐观向上，永不放弃\n专业执着，精益求精","name5":"鲜入为主深耕全球优质供应链，精选上千款生鲜产品","value5":"产品分类多样，主打生鲜乳制品，鲜入为主深耕全球优质供应链，精选上千款生鲜产品，\n30个国家直采，首次挑选合格率高达95%的产品才有资格二次入库挑选，只为您提供更优质服务。"}}}

/***/ })
],[18]);


// WEBPACK FOOTER //
// static/js/app.d78a1d78c97d3c922f16.js